const titleSx = {
  fontSize: { md: 14, lg: 14, xl: 15, xxl: 20, xxxl: 28 },
  lineHeight: { md: '13px', lg: '14px', xl: '18px', xxl: '24px', xxxl: '26px' },
  minHeight: { md: '28px', lg: '28px', xl: 'auto', xxl: '40px', xxxl: '45px' },
  textAlign: 'start',
  color: '#707991',
}

const valuesSx = {
  fontSize: { md: '14px', lg: '16px', xl: '22px', xxl: '24px', xxxl: '36px' },
  lineHeight: { md: '16px', lg: '18px', xl: '28px', xxl: '34px', xxx: '40px' },
  color: '#1C2842',
  fontFamily: 'Dosis',
  fontWeight: 500,
  textTransform: 'capitalize',
}

const dataSx = {
  maxWidth: { lg: 100, xl: 124, xxxl: 200 },
  textAlign: 'start',
}

const styles = {
  titleSx,
  valuesSx,
  dataSx,
}

export default styles
